import React, { useState, useEffect } from 'react';
import '../../styles/ui/OnboardingTooltip.css';

const STORAGE_KEY = 'adwary_onboarding_dismissed';

const STEPS = [
  { emoji: '1️⃣', text: 'اختر محل من القائمة' },
  { emoji: '2️⃣', text: 'اختر نوع الخدمة' },
  { emoji: '3️⃣', text: 'حدد الموعد المناسب' },
];

function OnboardingTooltip() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch { /* ignore */ }
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch { /* ignore */ }
  };

  if (!visible) return null;

  return (
    <div className="onboarding-tooltip" role="dialog" aria-label="كيفية الحجز">
      <button type="button" className="onboarding-dismiss" onClick={dismiss} aria-label="إغلاق">
        ×
      </button>
      <p className="onboarding-title">كيف تحجز؟</p>
      <ul className="onboarding-steps">
        {STEPS.map((step) => (
          <li key={step.text}>
            <span aria-hidden="true">{step.emoji}</span>
            {step.text}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OnboardingTooltip;
